<div id="sankey_multiple" >

    <div id="3nkcharts">

        <div id="chartsix"></div>



        <button mat-button id="coolingbtn" (click)="chartCooling()">Impact on Cooling</button>
        <button mat-button id="heatingbtn" (click)="chartHeatingSolar()">Impact on Heating</button>

        <span id="text" class="d-none">Checkbox is CHECKED!</span>

    </div>

    <div id="heating"></div>
    <div id="chartcooling"></div>
    <div id="heatingLoad">Total heating peak load : {{ total_heating_load | number:'1.1-2' }} kW</div>
    <div id="coolingLoad">Total cooling peak load : {{ total_cooling_load | number:'1.1-2' }} kW</div>
    <div id="heatingdivider"><span id="gain">Gains &#160; &#8593;&#160;(+ve)</span><span id="Loss">Losses &#8595;&#160;
            (-ve)</span></div>

    <div id="coolingdivider"><span id="gain">Gains &#160; &#8593;&#160;(+ve)</span><span id="Loss">Losses &#8595;&#160;
            (-ve)</span></div>

</div>